import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/app/(public)/course-info/components/hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/modal/notify-me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/recommend-us/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/basic-traning-frontend/node_modules/next/dist/client/app-dir/link.js");
